// AlertPopup.js
import { Alert } from "@mui/material";
import type { AlertColor } from "@mui/material/Alert";
import useAlert from "../hooks/useAlert";

const AlertPopup = () => {
  const { text, type } = useAlert();

  if (text && type) {
    return (
      <Alert
        severity={type as AlertColor}
        sx={{
          position: 'absolute',
          zIndex: 10,
        }}
      >
        {text}
      </Alert>
    );
  } else {
    return <></>;
  }
};

export default AlertPopup;